import { saveAs } from "file-saver";
import moment from "moment";

export const handleAddToCalendar = (booking, hotelInfo) => () => {
  if (!booking) return;

  const startDate = moment(booking.fromdate, "DD-MM-YYYY").format(
    "YYYYMMDDTHHmmss"
  );
  const endDate = moment(booking.todate, "DD-MM-YYYY").format(
    "YYYYMMDDTHHmmss"
  );

  const icsContent = `
    BEGIN:VCALENDAR
    VERSION:2.0
    BEGIN:VEVENT
    SUMMARY:Booking Confirmation - ${hotelInfo?.hotelName}
    DESCRIPTION:Thank you ${booking.guestName} for booking at ${hotelInfo?.hotelName}.
    DTSTART:${startDate}
    DTEND:${endDate}
    LOCATION:${hotelInfo?.address}
    END:VEVENT
    END:VCALENDAR`;

  const blob = new Blob([icsContent], {
    type: "text/calendar;charset=utf-8",
  });
  saveAs(blob, `Booking_${booking.bookingId}.ics`);
};
